import { faEdit, faUsers } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { cloneDeep } from 'lodash'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import TableAdvanced from '../../../../../components/Tables/TableAdvanced/TableAdvanced'
import { getDataFile } from '../../../../../helpers/helpers'
import { useLang } from '../../../../../language'
import { ModalVerCalendario } from './ModalVerCalendario'
import { OfertasServices } from './controllers/ofertas.service'
import ButtonOrderBy from '../../../../../components/ButtonOrderBy/ButtonOrderBy'

export const TableEventos = ({ data, loading, total, perPage, handleFormChange, formValuesSearch,
    urlParams, fetchPersonasGET, handleInputChangeSearch }: any) => {

    const navigate = useNavigate();

    const Lang = useLang()

    const [excluidos, setExcluidos] = useState([])
    const [incluidos, setIncluidos] = useState([])

    const [checkAll, setCheckAll] = useState(false)

    const selectAllItems = () => {
        setCheckAll(true)
        setIncluidos([])
        setExcluidos([])
    }

    const unselectAllItems = () => {
        setCheckAll(false)
        setIncluidos([])
        setExcluidos([])
    }

    const allActions: any = [
        // {
        //     label: <span className='me-2'><FontAwesomeIcon icon={faCalendar} className='me-2' />{Lang('VER_CALENDARIO')}</span>,
        //     variant: 'outline-primary',
        //     action: () => handleShowModal_VerCalendario({}),
        // },
    ]

    const allActionsPerLine = [
        {
            label: <FontAwesomeIcon icon={faEdit} className='' />,
            // action: (id: string) => navigate(`/visados-admin/visados/${id}`),
            action: (id: string) => navigate(`./${id}`),
        },
        {
            variant: 'outline-primary',
            label: <FontAwesomeIcon icon={faUsers} className='' />,
            // action: (id: string) => navigate(`/visados-admin/visados/${id}`),
            action: (id: string) => navigate(`./${id}/inscripciones`),
        }
    ]

    const handleChangeCheckAll = (e: any) => {

        if (e.target.checked) {

            selectAllItems()

        } else {

            unselectAllItems()
        }
    }

    const headersTable = [
        <small>
            <ButtonOrderBy
                label={Lang('OFERTA')}
                id='nombreoferta'
                className='text-center'
                handleInputChange={handleInputChangeSearch}
                formValuesSearch={formValuesSearch}
            />
        </small>,
        <small>{Lang('HORARIO')}</small>,
        <small>{Lang('ENTIDAD')}</small>,
        <small className='d-block text-center'>
            <ButtonOrderBy
                label={Lang('FECHA_INICIO')}
                id='fpublicacioninicio'
                className='text-center'
                handleInputChange={handleInputChangeSearch}
                formValuesSearch={formValuesSearch}
            />
            
            </small>,
        <small className='d-block text-center'>{Lang('ESTADO')}</small>,
        ''
    ]

    const dataLineTable = [
        {
            className: '',
            name: 'nombreoferta'
        },
        {
            className: '',
            name: 'horario'
        },

        {
            name: 'entidad'
        },
        {
            className: 'text-nowrap text-center',
            name: 'label__fpublicacioninicio'
        },
        {
            className: 'text-nowrap text-center',
            name: 'estado_oferta'
        },
    ]

    // Descargar Excel

    const [showConfirm_Excel, setshowConfirm_Excel] = useState(false)

    const [fetchVisadosGETExcel, fetchVisadosGETExcelData, resetfetchVisadosGETExcel] = OfertasServices.GET_EXCEL()

    useEffect(() => {

        if (fetchVisadosGETExcelData.status === 200) {
            getDataFile(fetchVisadosGETExcelData, resetfetchVisadosGETExcel, 'Visados', 'xlsx')
            setshowConfirm_Excel(false)
        }
    }, [fetchVisadosGETExcelData])

    const handleClickExcel = () => {

        setshowConfirm_Excel(true)

        let urlParamsTemp = cloneDeep(urlParams)
        delete urlParamsTemp['page']

        fetchVisadosGETExcel({
            params: {
                ...urlParamsTemp,
                to_excel: 1
            }
        })
    }

    // Modal Crear visado

    const [showModal_VerCalendario, setShowModal_VerCalendario] = useState({
        value: false,
        payload: {}
    });

    const handleCloseModal_VerCalendario = () => setShowModal_VerCalendario({
        value: false,
        payload: {}
    });

    const handleShowModal_VerCalendario = (payload: object) => setShowModal_VerCalendario({
        value: true,
        payload
    });

    return (
        <>

            <TableAdvanced >

                <TableAdvanced.Head
                    title={Lang('LISTA_DE_OFERTAS')}
                    allActions={allActions}
                />

                <TableAdvanced.Body
                    headers={headersTable}
                    dataLineTable={dataLineTable}
                    data={data}
                    isLoading={loading}

                    excluidos={excluidos}
                    incluidos={incluidos}
                    setExcluidos={setExcluidos}
                    setIncluidos={setIncluidos}

                    checkAll={checkAll}
                    allActionsPerLine={allActionsPerLine}
                    checkMultiples={false}
                />

                <TableAdvanced.Footer
                    total={total}
                    handleFormChange={handleFormChange}
                    formValuesSearch={formValuesSearch}
                    perPage={perPage}
                />

            </TableAdvanced>

            <ModalVerCalendario
                showModal_VerCalendario={showModal_VerCalendario}
                handleCloseModal_VerCalendario={handleCloseModal_VerCalendario}
            />

        </>
    )
}
